import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FreightManagerModalService {

  private selectedFreightManagerSubject = new BehaviorSubject<any>(null);
  public selectedFreightManager$ = this.selectedFreightManagerSubject.asObservable();

  constructor() { }

  setSelectedFreightManager(freightManager: any): void {
    this.selectedFreightManagerSubject.next(freightManager);
  }

  getSelectedFreightManager(): any | null {
    return this.selectedFreightManagerSubject.value;
  }

  clearSelectedFreightManager(): void {
    this.selectedFreightManagerSubject.next(null);
  }
}
